import React, { useCallback } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  CircularProgress,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

interface ProductListSearchProps {
  value: string;
  onSearch: (query: string) => void;
  onClear: () => void;
  loading: boolean;
  resultCount?: number;
  total?: number;
}

export function ProductListSearch({
  value,
  onSearch,
  onClear,
  loading,
  resultCount,
  total,
}: ProductListSearchProps) {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onSearch(e.target.value);
    },
    [onSearch]
  );

  const handleClear = useCallback(() => {
    onClear();
  }, [onClear]);

  return (
    <Box sx={{ mb: 3 }}>
      <TextField
        fullWidth
        placeholder="Buscar por código o nombre..."
        value={value}
        onChange={handleChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'action.active' }} />
            </InputAdornment>
          ),
          endAdornment: loading ? (
            <InputAdornment position="end">
              <CircularProgress size={20} />
            </InputAdornment>
          ) : value ? (
            <InputAdornment position="end">
              <ClearIcon
                onClick={handleClear}
                sx={{ cursor: 'pointer', color: 'action.active' }}
              />
            </InputAdornment>
          ) : null,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#fff',
          },
        }}
      />
      {value && resultCount !== undefined && total !== undefined && (
        <Typography variant="caption" sx={{ mt: 1, display: 'block', color: 'text.secondary' }}>
          {resultCount} de {total} productos encontrados
        </Typography>
      )}
    </Box>
  );
}
